// HEX transparency values here:
// https://gist.github.com/lopspower/03fb1cc0ac9f32ef38f4
export const colors = {
  cl_color_blue: '#2C7BE5',
  cl_color_blue_transparent: '#2C7BE555',
  cl_color_dark_blue: '#16263D',
  cl_color_hover_blue: '#0757c1',
  cl_color_hover_blue_range_selection: '#4681D0',
  cl_color_mid_blue: '#337AB7',
  cl_color_mid_transparent_blue: '#337AB733',
  cl_color_blue_click: '#014298',
  cl_color_hover_regular: '#525f74',
  cl_color_regular_click: '#454f5f',
  cl_color_dark_blue_black: '#283852',
  cl_color_dark_blue_grey: '#3A4665',
  cl_color_chart_blue: '#38c3ff',
  cl_color_light_blue: '#73C5E8',
  cl_color_lighter_blue: '#BFECFF',
  cl_color_text_dark_bg: '#9CB3D8',
  cl_color_bubble_blue: '#CFE0F7',
  cl_color_bubble_blue_50_percent_opacity: '#CFE0F780',
  cl_color_light_bubble_blue: '#E7EFFB',

  cl_color_blue_gray: '#9DB0CA',
  cl_color_dark_gray: '#7284A1',
  cl_color_dark_gray_transparent: '#7284A1cc',
  cl_color_disable_gray: '#C3CDDA',
  cl_color_mid_gray: '#D2DDEC',
  cl_color_mid_gray_no_blue: '#FAFAFA',
  cl_color_mid_gray_lighten: '#DCDCDC',
  cl_color_mid_gray_darken: '#B2C0D3',
  cl_color_mid_gray_lightly_transparent: '#D2DDECD9',
  cl_color_shadow_gray: '#00000029',
  cl_color_light_gray: '#F8F9FB',
  cl_color_gray_lighten: '#D1D8E8',
  cl_color_light_transparent_gray: '#F8F9FB33',
  cl_color_extra_grey_1: '#ECF0F8',
  cl_color_blue_grey_lighten: '#CEDAEB',
  cl_color_light_blue_grey: '#F0F3F7',
  cl_color_dark_theme_gray_lighten: '#7F7F7F',
  cl_color_dark_theme_gray_darken: '#6E6E6E',

  cl_color_green: '#00D97F',
  cl_color_green_olive: '#A4C639',
  cl_color_light_green: '#5CBE9B',
  cl_color_dark_green: '#53A889',
  cl_color_mid_green: '#25A18E',
  cl_color_green_bright: '#A4C639',
  cl_color_green_transparent: '#00D97F30',
  cl_color_yellow: '#EACB28',
  cl_color_light_yellow: '#FDF3D0',
  cl_color_yellow_bright: '#FFC532',
  cl_color_yellow_mustard: '#DFA307',
  cl_color_orange: '#FF8A16',
  cl_color_orange_deep: '#F46036',
  cl_color_red: '#ED2546',
  cl_color_light_red: '#FFE3E3',
  cl_color_deep_red: '#B90000',
  cl_color_red_bright: '#FF0000',
  cl_color_red_transparent: '#ED254630',
  cl_color_red_peach: '#FBD3DA',
  cl_color_violet: '#55097B',
  cl_color_violet_light: '#9100B4',

  cl_color_white: '#FFFFFF',

  cl_color_black: '#000000',
  cl_color_black_transparent: '#00000033',

  cl_color_orange_red: '#B74E11',
  cl_color_orange_red_transparent: '#B74E1133',

  cl_color_grey_hover: '#525F74',
  cl_color_grey_hover_opacity: '#525F7488',
  cl_color_grey_click: '#454F5F',

  cl_color_disabled_grey: '#737373',
  cl_color_disabled_grey_semi_transparent: '#73737333',

  cl_color_light_dimmed_blue: '#E3EFFF',
  cl_color_light_dimmed_grey: '#F4F4F4',
};
